import { render, staticRenderFns } from "./CoreItemTwo.vue?vue&type=template&id=7b59ae9d&scoped=true"
import script from "./CoreItemTwo.vue?vue&type=script&lang=js"
export * from "./CoreItemTwo.vue?vue&type=script&lang=js"
import style0 from "./CoreItemTwo.vue?vue&type=style&index=0&id=7b59ae9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b59ae9d",
  null
  
)

export default component.exports